import { Component, Input, OnInit } from "@angular/core";
import { VidalyticsLoaderService } from "src/app/services/vidalytics.service";

@Component({
  selector: "video-player-vidalytics",
  templateUrl: "video-player-vidalytics.html",
  styleUrls: ["video-player-vidalytics.scss"],
})
export class VideoPlayerVidalyticsComponent implements OnInit {
  @Input() vidalyticsEmbedId: string = "";
  videoClass = "vidalytics";

  constructor(public vidalyticsLoaderService: VidalyticsLoaderService) {}

  async ngOnInit() {
    this.setVidalytics();
  }

  // Load vidalytics
  setVidalytics() {
    this.vidalyticsLoaderService.loadVidalytics({
      vidalyticsEmbedId: this.vidalyticsEmbedId,
      buttonId: "button",
      showClass: "video__nextPageShown",
      hideClass: "video__nextPageHidden",
    });
  }
}
